import React from "react";
import {Container} from "react-bootstrap";
import SalesFilterHeader from "../../Components/Statistics/SalesFilterHeader.jsx";
import useSalesFilters from "../../Components/Statistics/useSalesFilters.js";
import KpiCards from "../../Components/Statistics/KpiCards.jsx";
import RevenueTrendChart from "../../Components/Statistics/RevenueTrendChart.jsx";
import RevenueByGroupChart from "../../Components/Statistics/RevenueByGroupChart.jsx";
import GroupComparisonChart from "../../Components/Statistics/GroupComparisonChart.jsx";
import SeasonalityChart from "../../Components/Statistics/SeasonalityChart.jsx";

/**
 * Überblick - der ehemalige "Dashboard"-Reiter der Verkaufsstatistik, seit
 * August 2026 eine eigene Unterseite (siehe StatisticsController::index()).
 * Zeigt genau einen Zweck: die zentralen Kennzahlen auf einen Blick -
 * Kennzahlen-Kacheln, Umsatzverlauf, Warengruppen-Vergleich und Saisonalität.
 * Detailtabelle, Sortimente, Renner/Penner und Lagerstrategie leben auf
 * eigenen Unterseiten.
 */
export default function StatisticsUeberblick() {
    const salesFilters = useSalesFilters();
    const {filters, colorMap, groupOrder} = salesFilters;

    return (
        <Container fluid className="pt-2 pb-4">
            <SalesFilterHeader title="Überblick" salesFilters={salesFilters}>
                <div className="d-flex flex-column gap-3">
                    <KpiCards filters={filters} />

                    <RevenueTrendChart filters={filters} />

                    <div className="row g-3">
                        <div className="col-lg-7">
                            <RevenueByGroupChart filters={filters} colorMap={colorMap} groupOrder={groupOrder} />
                        </div>
                        <div className="col-lg-5">
                            <GroupComparisonChart filters={filters} colorMap={colorMap} />
                        </div>
                    </div>

                    <SeasonalityChart filters={filters} />
                </div>
            </SalesFilterHeader>
        </Container>
    );
}
